import { IAddressSubSchema } from '../../../graphql/type/subSchema/address';
import language from './language';

const address = {
  format: (
    tempAddress?: IAddressSubSchema,
    options: {
      useCountryCode?: boolean;
    } = {
      useCountryCode: false,
    }
  ): string => {
    if (!tempAddress) {
      return '';
    }
    const arr = [];

    if (tempAddress.streetNo) {
      arr.push(tempAddress.streetNo);
    }

    if (tempAddress.streetName) {
      arr.push(tempAddress.streetName);
    }

    if (tempAddress.unitNo && tempAddress.buildingName) {
      arr.push(`#${tempAddress.unitNo} ${tempAddress.buildingName}`);
    } else if (!tempAddress.unitNo && tempAddress.buildingName) {
      arr.push(tempAddress.buildingName);
    } else if (tempAddress.unitNo && !tempAddress.buildingName) {
      arr.push(`#${tempAddress.unitNo}`);
    }

    if (tempAddress.town) {
      arr.push(tempAddress.town);
    }
    if (tempAddress.district) {
      arr.push(tempAddress.district);
    }
    if (tempAddress.city) {
      arr.push(tempAddress.city);
    }
    if (tempAddress.state) {
      arr.push(tempAddress.state);
    }

    if (options.useCountryCode) {
      if (tempAddress.country && tempAddress.zip) {
        arr.push(tempAddress.country);
        arr.push(tempAddress.zip);
      }
    } else {
      if (tempAddress.countryData) {
        arr.push(`${language.getText(tempAddress.countryData.name)}`);
      }

      if (tempAddress.zip) {
        arr.push(tempAddress.zip);
      }
    }

    return arr.join(', ').trim().replace(/\s\s+/g, ' ');
  },
};
export default address;
